import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import Countries from '../../util/countries';
import Image from '../../components/image';
import Label from '../../components/label';
import styles from './index.scss';
import Log from '../../util/log';

function GeoBlocker(props) {
  const { t, i18n, config, availableComponent, onComplete } = props;

  const [geoAvailable, setGeoAvailable] = useState(null);

  // Ensure allowed_regions is present and contains something
  const checkGeoBlocker =
    config.geo_blocking?.allowed_regions && config.geo_blocking.allowed_regions.length !== 0;

  useEffect(() => {
    if (checkGeoBlocker) {
      // Get whitelist from config
      const countryWhitelist = config.geo_blocking.allowed_regions.map((code) =>
        code.toLowerCase()
      );

      const apiKey = config.ipregistry_api_key;

      // Find user country code
      Countries.detectIPRegistry(apiKey)
        .then((countryInfo) => {
          // Check if any info was returned
          if (!countryInfo) {
            setGeoAvailable(true);
            return;
          }

          const code = countryInfo.code.toLowerCase();

          // Check if whitelisted
          if (countryWhitelist.includes(code)) {
            setGeoAvailable(true);
          } else {
            Log.error(`GeoBlocker > Country code ${code} blocked.`);
            // only dismiss loader in failure case
            onComplete();
            setGeoAvailable(false);
          }
        })
        .catch((error) => {
          Log.error(`GeoBlocker > Encountered on error ${error}.`);
          onComplete();
          setGeoAvailable(false);
        });
    } else {
      setGeoAvailable(true);
    }
  }, []);

  // Check if whitelisted
  if (geoAvailable) {
    return availableComponent();
  }

  const fallbackPage = (
    <div className={clsx('geo-blocking-container', styles.container)}>
      <div className={clsx('geo-blocking-background-image-container', styles.imageContainer)}>
        <Image
          alt=""
          src={
            i18n.exists('geo_blocking.background_image.src')
              ? t('geo_blocking.background_image.src')
              : ''
          }
          className={clsx('geo-blocking-background-image', styles.image)}
        />
      </div>
      <div className={clsx('geo-blocking-inner-container', styles.innerContainer)}>
        <Label
          className={clsx('geo-blocking-text', styles.message)}
          text={t('geo_blocking.text')}
        />
        <div className={clsx('geo-blocking-footer-space', styles.footerSpace)} />
      </div>
    </div>
  );

  // Show geo restricted
  return fallbackPage;
}

export default withTranslation()(GeoBlocker);
